export default __webpack_public_path__ + "static/media/sa-6.d31c041a.png";